(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page--content-v2"]) return;
  try {
    
   (function(){
       document.addEventListener("click", function(e) {
         var answers = document.querySelectorAll('.avo-faq-answer');
         answers.forEach(function(el) {
             el.style.setProperty('display', 'none', 'important');
         });
         var item = e.target;
         if(item) {
           faqItem = item.closest('.avo-faq-item');
            var answer = faqItem.querySelector('.avo-faq-answer');
           var isOpen = faqItem.classList.contains('avo-open');
           if (!isOpen) {
             faqItem.classList.add('avo-open');
                          answer.style.setProperty('display', 'block', 'important');
             return
          }
           faqItem.classList.remove('avo-open');
           var a = faqItem.querySelector('.avo-faq-answer');
             if (a) a.style.setProperty('display', 'none', 'important');
          }
       })
   })()
  
  } catch(e) { console.error(e); }
})();
})();
